"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = flexCenter;
function flexCenter() {
  return /*css*/"\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n  ";
}